import { createContext } from 'react'

import type { Company } from '@/types/dashboard-types'

export interface CompanyContextType {
  companies: Company[]
  companyId?: number
  setCompanyId: (companyId?: number) => void
  isLoading: boolean
}

export const CompanyContext = createContext<CompanyContextType>({
  companies: [],
  isLoading: true,
  setCompanyId: (_companyId?: number) => null,
})
